import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import '../Pages/AddData.css'
import {  useSelector , useDispatch} from 'react-redux'
import { deleteData } from '../REDUX/Action'
import { updateStatus } from '../REDUX/Action'
import {Trash,FolderOpenDot,CircleEllipsis,CheckSquare} from 'lucide-react'



function AddData() {
    const nav=useNavigate()
     const state = useSelector((data) => data);
     const dispatch = useDispatch();
     
 
    const handleTask=()=>{
         nav('/')
    }
    const handleUpdateStatus = (task, status) => {
        // Dispatch the action when a status update button is clicked
        dispatch(updateStatus(task, status));
    }
    
  return (
    <>
    <div className='head'>
        <h1>Check List: Tasks</h1>
    </div>
    <div className='data'>
        <table className='table'>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Tasks</th>
                    <th>From </th>
                    <th>To </th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Update Status</th>
                    <th>Delete</th>
                    
                    
                </tr>
            </thead>
            <tbody>
                {
                    state.UserReducer.user.map((i,index)=>(
                        <tr key={i.id}>
                        <td>{index+1}</td>
                        <td>{i.task}</td>
                        <td>{i.timef}</td>
                        <td>{i.timet}</td>
                        <td>{i.date}</td>
                        <td>{i.status}</td>
                        <td className='td'>
                        <button style={{marginLeft:"2px"}} className='btn btn-outline-info'  onClick={() => handleUpdateStatus(i.task, 'open')}><FolderOpenDot /></button>
                        <button style={{marginLeft:"2px"}} className='btn btn-outline-warning' onClick={() => handleUpdateStatus(i.task, 'in-progress')}><CircleEllipsis /></button>
                        <button style={{marginLeft:"2px"}} className='btn btn-outline-success' onClick={() => handleUpdateStatus(i.task, 'completed')}><CheckSquare /></button>
                        </td>
                        <td><button onClick={()=>dispatch(deleteData(index))} type="button" className="btn btn-outline-danger"><Trash /></button></td>
                        
                        </tr>
                    ))
                }
           </tbody>
        </table>
    </div>
    <div className='btn'>      
          <button type="button" onClick={handleTask} className="btn btn-outline-dark">Add More Task</button>
   </div>
    </>
    
  )
}

export default AddData